<template lang="pug">
  app-plotly(nomeDiv="graficoQuantidadeProcessoMunicipio", :dados="graficoDados", :layout="layout")
</template>

<script>
import AppPlotly from '../shared/AppPlotly'
import { colors } from '../../../../../utils/constantes'

export default {
  components: {
    AppPlotly
  },

  props: {
    dadosLabels: {
      required: true
    }
  },

  data () {
    return {
      dados: [],
      layout: {
        showlegend: true,
        height: 450,
        legend: {
          orientation: 'v'
        },
        xaxis: {
          showticklabels: false,
          title: 'Município',
          range: [-0.5, 9.5]
        },
        yaxis: {
          title: 'Quantidade de Processos'
        },
        margin: {
          b: 45,
          l: 45,
          t: 45
        }
      },
      colors,
      loading: true
    }
  },

  computed: {

    dadosWithColor () {
      return this.dadosLabels.map((dado, index) => ({
        ...dado,
        color: this.colors[index]
      }))
    },

    graficoDados () {
      if (_.isEmpty(this.dadosLabels)) {  // eslint-disable-line
        return []
      }

      const graficoDados = []

      for (let index = 0; index < this.dadosWithColor.length; index++) {
        graficoDados.push({
          x: [this.dadosWithColor[index].label],
          y: [this.dadosWithColor[index].valor],
          type: 'bar',
          text: this.dadosWithColor[index].valor,
          textposition: 'auto',
          textfont: {
            size: 14
          },
          name: this.dadosWithColor[index].label,
          hoverinfo: 'none',
          marker: { color: [this.dadosWithColor[index].color] }
        })
      }

      return graficoDados
    },

    hasData () {
      return !_.isEmpty(this.dados)  // eslint-disable-line
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/graficos/GraficoQuantidadeProcessoMunicipio.vue